import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        cardContent: {
            marginTop: theme.spacing(2),
            height: 755,
        },
        requiredContainers: {
            marginTop: theme.spacing(2),
        },
    }
})

export default useStyles
